import { DownloadBox } from 'components/shared/DownloadBox';
import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const typographyDownload = [
    <div key="1">
        <p>
            Typography is another essential element of the Free Market Health identity. Consistent
            use of the prescribed typeface throughout brand communications will help maintain a
            cohesive visual style.
        </p>
        <p>
            Our brand typeface is Libre Franklin. Like the brand itself, these letterforms are
            strong, versatile, and modern. Libre Franklin is used in both print and web
            applications.
        </p>
    </div>,
    <div key="2" className="sds_typography-example__container padding__around--large">
        <div>
            <div className="sds_typography-example__title">Libre Franklin</div>
            <div className="sds_typography-example__description">
                Used for print and web applications.
            </div>
        </div>
        <div className="sds_typography-example__content">
            Enhancing the specialty pharmacy system for the benefit of pharmacies, payers and
            patients.
        </div>
    </div>,
    <DownloadBox
        key="3"
        title="Libre Franklin"
        fileType="ZIP"
        fileSize="111 kb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/Libre-Franklin.zip"
    />,
];

const logoDownload = [
    <p key="4">
        Downloadable files for all Free Market Health logos with variations. Always use these
        approved logo files and never recreate or adjust the design of logos.
    </p>,
    <DownloadBox
        key="5"
        title="Primary Logos"
        fileType="ZIP"
        fileSize="1.1 mb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/01_FMH_Primary.zip"
    />,
    <DownloadBox
        key="6"
        title="One-Line Logos"
        fileType="ZIP"
        fileSize="1 mb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/02_FMH_One_Line.zip"
    />,
    <DownloadBox
        key="7"
        title="Short Logos"
        fileType="ZIP"
        fileSize="996 kb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/03_FMH_Short.zip"
    />,
    <DownloadBox
        key="8"
        title="Flag Icon Logos"
        fileType="ZIP"
        fileSize="996 kb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/04_Flag_Icon.zip"
    />,
    <DownloadBox
        key="9"
        title="FMH for Payers Logos"
        fileType="ZIP"
        fileSize="1.4 mb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/05_FMH_For_Payers.zip"
    />,
    <DownloadBox
        key="10"
        title="FMH for Pharmacies Logos"
        fileType="ZIP"
        fileSize="1.4 mb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/06_FMH_For_Pharmacies.zip"
    />,
];

export const Downloads = () => (
    <div>
        <Page
            pageTitle="Downloads"
            pageDescription="This page features downloads for Free Market Health typography and logos."
            pageContent={
                <>
                    <Section title="Typography" contentArray={typographyDownload} />
                    <Section title="Logos" contentArray={logoDownload} />
                </>
            }
        />
    </div>
);
